export default "__VITE_ASSET__BFgSusmj__"